import { api_GET } from "api/axios.js";

const estoque_api =
{
    getDashboard: function(id){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`estoque/getDashboard/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getList: function(id){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`estoque/GetListByLocal/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    }

}

export default estoque_api
